/*
    Create by Baizhiming 2015-11-30
*/
'use strict';
angular
    .module('myManuscriptService', [
        'iWoDraftModule',
        'iWoSbumitModule',
        'copyBuildDraftModule',
        'getDraftModule',
        'iWoRejectionModule',
        'departSubmitModule',
        'historyDraftsModule',
        'iwoDepartRejectionModule',
    ])
    .factory('myManuscriptService', [
        '$modal',
        '$q',
        '$state',
        'trsHttpService',
        'modalDialog',
        'trsspliceString',
        'editIsLock',
        'editingMediatype',
        'editingCenterService',
        'storageListenerService',
        function ($modal, $q, $state, trsHttpService, modalDialog, trsspliceString, editIsLock, editingMediatype, editingCenterService, storageListenerService) {

            /**
             * [packageTrenchParams description] 组装渠道参数
             * @param   {[array]}  gather         [gather description] 集合
             * @param   {[object]}  routerParams  [routerParams description] 路由参数
             * @return  {[object]}                [return description] 组装好的路由参数
             */
            function packageTrenchParams(gather, routerParams = {}){
                angular.forEach(gather, function(value) {
                    value.MEDIATYPE = value.MEDIATYPE * 1;
                    if (value.MEDIATYPE === editingMediatype.app) {
                        routerParams.appsiteid = value.SITEID;
                        routerParams.appchannelid = value.CHANNELID;
                        routerParams.appchnldocid = value.CHNLDOCID;
                        routerParams.appmetadataid = value.VIRTUALDOCID;
                    } else if (value.MEDIATYPE === editingMediatype.website) {
                        routerParams.wzsiteid = value.SITEID;
                        routerParams.wzchannelid = value.CHANNELID;
                        routerParams.wzchnldocid = value.CHNLDOCID;
                        routerParams.wzmetadataid = value.VIRTUALDOCID;
                    } else if (value.MEDIATYPE === editingMediatype.newspaper) {
                        routerParams.paperid = value.CHANNELID;
                        routerParams.papermetadataid = value.VIRTUALDOCID;
                    } else if (value.MEDIATYPE === editingMediatype.weixin) {
                        routerParams.wxchannelid = value.CHANNELID;
                        routerParams.wxchnldocid = value.CHNLDOCID;
                        routerParams.wxmetadataid = value.VIRTUALDOCID;
                    } else if (value.MEDIATYPE === editingMediatype.weibo) {
                        routerParams.wbmetadataid = value.VIRTUALDOCID;
                    } else if (value.MEDIATYPE === editingMediatype.trill) {
                        routerParams.douyinarticleid = value.VIRTUALDOCID;
                    } else if (value.MEDIATYPE === editingMediatype.baijiahao) {
                        routerParams.baijiahaoarticleid = value.VIRTUALDOCID;
                    } else if (value.MEDIATYPE === editingMediatype.qiehao) {
                        routerParams.qiehaoarticleid = value.VIRTUALDOCID;
                    } else if (value.MEDIATYPE === editingMediatype.toutiaohao) {
                        routerParams.articleid = value.VIRTUALDOCID;
                    }
                });
                return routerParams;
            }

            /**
             * [fusionRouter description] 融合编辑跳转
             * @param   {[object]}  item   [item description] 稿件信息
             * @param   {[object]}  scope  [scope description] 页面控制器
             * @param   {[Number]}  plat   [plat description] 平台标识
             * @return  {[type]}           [return description]
             */
            function fusionEditRouter(item, scope, plat = 0){
                let routerParams, url;
                let docType = angular.isObject(item) ? item.DOCTYPEID : item;
                let doctypeName = editingCenterService.getDocTypName(docType);
                routerParams = {
                    iwoplatform: plat,
                    wzplatform: 0,
                    appplatform: 0,
                    newspapertype: 2,
                    wxplatform: 0,
                    wbplatform: 0,
                    iwometadataid: item.METADATAID,
                    iwochnldocid: item.CHNLDOCID,
                    departmentaldocid: scope.status.departmentDocId,
                    fromType: scope.status.departmentDocId ? 'departmentmanuscript' : '',
                    departdocrelid: item.DEPARTDOCRELID,
                    isfromplannedorder: false
                };
                if (doctypeName === '广电文稿') {
                    url = $state.href('iwobroadcasttvmanuscript', routerParams);
                } else if (doctypeName === '串联单') {
                    let target = angular.isObject(item) ? 'iwoplannedorderedit' : 'iwoplannedorder';
                    url = $state.href(target, routerParams);
                } else {
                    routerParams = packageTrenchParams(scope.status.relatedChannelInfos, routerParams);
                    if (item.relatedInfo) {
                        routerParams = packageTrenchParams(item.relatedInfo, routerParams);
                    }
                    url = $state.href(scope.data.fusionRouter[docType], routerParams);
                }
                window.open(url);
            }

            /**
             * [fusionPreviewRouter description]
             * @param   {[Object]}  item          [item description]
             * @param   {[Object]}  scope         [scope description] 页面控制器
             * @param   {[Number]}  plat          [plat description] 平台标识
             * @param   {[String]}  momodalname   [plat description] 模块名称
             * @return  {[type]}                  [return description]
             */
            function fusionPreviewRouter(item, scope, plat = 0, momodalname = 'iwo.personal'){
                let routerParams, url;
                let docType = item.DOCTYPEID;
                let doctypeName = editingCenterService.getDocTypName(docType);
                routerParams = {
                    iwotype: docType,
                    iwomodalname: momodalname,
                    wzplatform: 0,
                    wztypeid: docType,
                    appplatform: 0,
                    newspapertype: 2,
                    iwoplatform: plat,
                    iwometadataid: item.METADATAID,
                    iwochnldocid: item.CHNLDOCID,
                    wxplatform: 0,
                    appdoctype: docType,
                    departmentDocId: scope.status.departmentDocId,
                    fromType: scope.status.departmentDocId ? 'departmentmanuscript' : '',
                    departdocrelid: item.DEPARTDOCRELID,
                };
                storageListenerService.previewPageTurningStorage(scope.data.items, 'METADATAID,CHNLDOCID,DOCTYPEID', 'fusionPreview'); // 为了上一篇、下一篇
                if (doctypeName === '广电文稿') {
                    url = $state.href('iwomanuscriptpreview', routerParams);
                } else if (doctypeName === '串联单') {
                    url = $state.href('iwoseriessheetpreview', routerParams);
                } else {
                    routerParams = packageTrenchParams(scope.status.relatedChannelInfos, routerParams);
                    if (item && item.relatedInfo) {
                        routerParams = packageTrenchParams(item.relatedInfo, routerParams);
                    }
                    url = $state.href('fusionpreview', routerParams);
                }
                window.open(url);
            }

            /**
             * [getRelatedMediaIds description] 获取关联渠道的相关信息
             * @param   {[type]}  doctype  [doctype description]
             * @return  {[type]}           [return description]
             */
            function getRelatedMediaIds(doctype){
                let defer = $q.defer();
                let params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'getMediaTypesByDocType',
                    doctype: doctype,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    // $scope.status.relatedChannelInfos = data;
                    defer.resolve(data);
                });
                return defer.promise;
            }

            /**
             * [getRelatedInfo description] 获取稿件的关联信息
             * @param   {[object]}  $scope              [$scope description]
             * @param   {[array]}  relatedChannelInfos  [relatedChannelInfos description]
             * @return  {[type]}                        [return description]
             */
            function getRelatedInfo($scope, relatedChannelInfos) {
                let defer = $q.defer();
                $scope.status.relatedChannelInfos = relatedChannelInfos;
                let items = $scope.data.items || [$scope.data.item]; // 兼容列表页与查看页面
                if (!items || items.length < 1) {
                    defer.resolve([]);
                } else {
                    let params = {
                        serviceid: 'mlf_fusioncreate',
                        methodname: 'queryFuseMappingsByDocIds',
                        sourceDocIds: trsspliceString.spliceString(items, 'METADATAID', ','),
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        defer.resolve(data);
                    });
                }
                return defer.promise;
            }
            return {

                /**
                 * [relatedReport description]稿件管理报题
                 * @param   {[type]}  params  [params description]稿件关联选题所需参数
                 * @return  {function}        [return description]
                 */
                relatedReport: function (params) {
                    var defer = $q.defer();
                    angular.extend(params, {
                        methodname: 'saveReportMetaDatas',
                        serviceid: 'mlf_newreport',
                    });
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        if (data.ISSUCCESS === 'true') {
                            // modalDialog.alertType("关联选题成功", "", "success", false);
                            defer.resolve();
                        } else {
                            defer.reject();
                        }
                    });
                    return defer.promise;
                },

                /**
                 * [relatedReport description]稿件关联任务
                 * @param   {[type]}  params  [params description]稿件关联任务所需参数
                 * @return  {function}        [return description]
                 */
                relatedTask: function (params) {
                    var defer = $q.defer();
                    angular.extend(params, {
                        methodname: 'saveTaskCommandMetaDatas',
                        serviceid: 'mlf_taskcommand',
                    });
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function (data) {
                        if (data.ISSUCCESS === 'true') {
                            // modalDialog.alertType("关联选题成功", "", "success", false);
                            defer.resolve();
                        } else {
                            defer.reject();
                        }
                    });
                    return defer.promise;
                },

                draft: function (title, array, success, fail, methodname, returnArray, recentOperator) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/iWo/myManuscript/service/draft/draft_tpl.html',
                        windowClass: 'myManuscript-draft',
                        backdrop: false,
                        controller: 'iWoDraftCtrl',
                        resolve: {
                            incomeData: function () {
                                var incomeData = {
                                    title: title,
                                    array: array,
                                    methodname: methodname,
                                    recentOperator: recentOperator,
                                };
                                return incomeData;
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        if (result === 'success') {
                            success();
                        } else if (angular.isObject(result)) {
                            returnArray(result);
                        } else if (result === 'fail') {
                            fail();
                        }
                    });
                },
                submit: function (selectedArray, methodname) {
                    let defer = $q.defer();

                    /**
                     * [queryDocsMediaType 查询所属渠道]
                     * @return {[type]} [description]
                     */
                    function queryDocsMediaType() {
                        var defer = $q.defer();
                        var params = {
                            serviceid: 'mlf_fusioncreate',
                            methodname: 'queryDocsMediaType',
                            ObjectIds: trsspliceString.spliceString(selectedArray, 'METADATAID', ','),
                        };
                        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                            defer.resolve(data);
                        });
                        return defer.promise;
                    }

                    /**
                     * [formatParams 格式化参数]
                     * @param  {[type]} data [description]
                     * @return {[type]}      [description]
                     */
                    function formatParams(data) {
                        var TvWenGao,
                            BroadCastWenGao = [];
                        TvWenGao = selectedArray.filter(function (item, index) {
                            return data[item.METADATAID][0] == '15';
                        });
                        BroadCastWenGao = selectedArray.filter(function (item, index) {
                            return data[item.METADATAID][0] == '16';
                        });
                        return {
                            TvWenGao: TvWenGao,
                            BroadCastWenGao: BroadCastWenGao,
                        };
                    }
                    if (selectedArray[0].DOCTYPEID === '11') {
                        // 串联单类型的稿件提交的特殊处理 --start
                        queryDocsMediaType().then(function (data) {
                            var WenGaoDocs = formatParams(data);
                            modalDialog.alertType('', '确认提交到对应栏目?', 'ask', true, function () {
                                var params = {
                                    serviceid: 'mlf_fusionmyrelease',
                                    methodname: methodname,
                                    MetaDataIds: trsspliceString.spliceString(selectedArray, 'METADATAID', ','),
                                    CHNLDOCIDS: trsspliceString.spliceString(selectedArray, 'CHNLDOCID', ','),
                                };
                                if (WenGaoDocs.TvWenGao.length > 0) {params.TvWenGao = trsspliceString.spliceString(WenGaoDocs.TvWenGao, 'METADATAID', '');}
                                if (WenGaoDocs.BroadCastWenGao.length > 0) {params.BroadCastWenGao = trsspliceString.spliceString(WenGaoDocs.BroadCastWenGao, 'METADATAID', '');}
                                if ($state.params.iwometadataid) { // 部门看稿库需要解锁,但是目前路由问题会刷新页面，所以暂时解锁一遍
                                    editIsLock.normalLock($state.params.iwometadataid).then(() => {
                                        defer.resolve(params);
                                    });
                                } else {
                                    defer.resolve(params);
                                }

                            }); // 串联单类型的稿件提交的特殊处理 --end
                        });
                    } else {
                        var DepartmentaldocId = trsspliceString.getValuesBykey(selectedArray, "DEPARTMENTALDOCID", ",")[0];
                        var ChnlDocIds = trsspliceString.spliceString(selectedArray, "CHNLDOCID", ",");
                        var DocType = trsspliceString.getValuesBykey(selectedArray, "DOCTYPEID", ",")[0];
                        if (!DepartmentaldocId) {
                            DepartmentaldocId = $state.params.departmentaldocid;
                        }
                        modalDialog.confirmModal("提示", "是否确认签发稿件？",
                            function () {
                                // webs: 253,
                                var params = {
                                    DepartmentaldocId: DepartmentaldocId,
                                    ChnlDocIds: ChnlDocIds,
                                    DocType: DocType,
                                    papers: "",
                                    MlfApp: "",
                                    WeChat: "",
                                    PaperPubDate: "",
                                    methodname: "submit",
                                    serviceid: "mlf_departoperdoc"
                                };
                                defer.resolve(params);
                                //console.log("DepartmentaldocId:"+DepartmentaldocId);
                                // trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function (data) {
                                //     modalDialog.alertType(data.DETAIL, "签发成功", "success", !1)
                                //     $scope.callback();
                                // })

                            })

                        // var modalInstance = $modal.open({
                        //     templateUrl: './editingCenter/iWo/myManuscript/service/submit/submit_tpl.html',
                        //     windowClass: 'myManuscript-submit',
                        //     backdrop: false,
                        //     resolve: {
                        //         selectedArray: function () {
                        //             return selectedArray;
                        //         },
                        //         methodname: function () {
                        //             return methodname;
                        //         },
                        //     },
                        //     controller: 'iWoSubmitCtrl',
                        // });
                        // modalInstance.result.then(function (result) {
                        //     console.log(result)
                        //     defer.resolve(result);
                        //     //result === 'request' ? success() : fail();
                        // }, function () {
                        //     defer.reject();
                        // });
                    }
                    return defer.promise;
                },

                /**
                 * [array description] 传稿
                 * @param   {[type]}  array         [array description]
                 * @param   {[type]}  serviceid     [serviceid description]
                 * @param   {[type]}  methodname    [methodname description]
                 * @param   {[type]}  darftservice  [darftservice description]
                 * @param   {[type]}  success       [success description]
                 * @param   {[type]}  returnArray   [returnArray description]
                 * @return  {[type]}                [return description]
                 */
                getDraft: function (array, service, success, returnArray) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/iWo/myManuscript/service/getDraft/getDraft_tpl.html',
                        windowClass: 'toBeCompiled-getDraft',
                        backdrop: false,
                        controller: 'getDraftCtrl',
                        resolve: {
                            params: function () {
                                var params = {
                                    service: service,
                                    array: array,
                                };
                                return params;
                            },
                            success: function () {
                                return success;
                            },
                        },
                    });
                    modalInstance.result.then(function (result) {
                        if (result === 'success') {
                            success();
                        } else if (angular.isObject(result)) {
                            returnArray(result);
                        }
                    });
                },
                rejection: function (selectedArray, success, error) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/iWo/myManuscript/service/rejection/rejection_tpl.html',
                        windowClass: 'myManuscript-rejection',
                        backdrop: false,
                        resolve: {
                            selectedArray: function () {
                                return selectedArray;
                            },
                        },
                        controller: 'iWoRejectionCtrl',
                    });
                    modalInstance.result.then(function (result) {
                        if (result !== 'error') {
                            success(result);
                        } else {
                            error();
                        }
                    });
                },

                /**
                 * [selectedArray description] 部门提交&&传递
                 * @param   {[type]}  selectedArray  [selectedArray description]
                 * @param   {[type]}  type           [type description]
                 * @param   {[type]}  success        [success description]
                 * @return  {[type]}                 [return description]
                 */
                departSubmit: function (selectedArray, type, success) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/iWo/myManuscript/service/departSubmit/departSubmit_tpl.html',
                        windowClass: 'departSubmit',
                        backdrop: false,
                        resolve: {
                            transData: function () {
                                return {
                                    selectedArray: selectedArray,
                                    type: type,
                                };
                            },
                        },
                        controller: 'departSubmitCtrl',
                    });
                    modalInstance.result.then(function (result) {
                        success(result);
                    });
                },
                departRejection: function (transferData, success, fail) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/iWo/myManuscript/service/departRejection/departRejection_tpl.html',
                        windowClass: 'iwoDepartRejection',
                        backdrop: false,
                        resolve: {
                            params: function () {
                                return transferData;
                            },
                        },
                        controller: 'iwoDepartRejectionCtrl',
                    });
                    modalInstance.result.then(function (result) {
                        if (result === 'success') {
                            success(result);
                        } else {
                            fail();
                        }
                    });
                },
                fusionRouter: fusionEditRouter,
                fusionPreviewRouter: fusionPreviewRouter,
                packageTrenchParams: packageTrenchParams,

                /**
                 * [getDraftRelatedInfo description]
                 * @param   {[type]}  $scope  [$scope description]
                 * @return  {[type]}          [return description]
                 */
                getDraftRelatedInfo: function($scope){
                    getRelatedMediaIds(1)
                        .then((relatedChannelInfos) => getRelatedInfo($scope, relatedChannelInfos))
                        .then((data) => {
                            let gather = $scope.data.items || [$scope.data.item];
                            angular.forEach(gather, function(value, key) {
                                value.relatedInfo = data[value.METADATAID];
                            });
                        });
                },
                // 部门稿库-历史稿件
                historyDrafts: function (success) {
                    var modalInstance = $modal.open({
                        templateUrl: './editingCenter/iWo/myManuscript/service/historyDrafts/historyDrafts_tpl.html',
                        windowClass: 'historyDrafts',
                        backdrop: false,
                        resolve: {
                            transData: function () {
                                return {
                                };
                            },
                        },
                        controller: 'historyDraftsCtrl',
                    });
                    modalInstance.result.then(function (result) {
                        success(result);
                    });
                },
                /**
                 * [queryDocStatus description]查询稿件状态
                 * @param   {[type]}  id      [id description]
                 * @param   {[type]}  type    [type description]
                 * @param   {[type]}  success [success description]
                 * @return  {type}            [return description]
                 */
                 queryDocStatus: function (id, type, success) {
                    var params = {
                        serviceid: 'mlf_departoperdoc',
                        methodname: 'queryDocStatus',
                        DocId: id,
                        DocType: type,
                    };
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                        if (data.ISSUCCESS === 'true') {
                            success();
                            var params1 = {
                                serviceid: 'mlf_departoperdoc',
                                methodname: 'markDocReader',
                                DocId: id,
                                DocType: type,
                            };
                            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params1, 'get').then(function (data) {
                                if (data.ISSUCCESS === 'true') {
                                    // modalDialog.alertType("阅读标记成功", "", "success", false);
                                } else {}
                            });
                        } else {}
                    });
                },
            };
        },
    ]);
